import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { m as merge } from '../../unsorted/index.js';
import { useConvertSxToEmotionStyles } from '../../hooks/useConvertSxToEmotionStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';

var _excluded = ["rc", "testId", "sx", "children", "domRef", "className"],
  _excluded2 = ["onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function BaseClickable(_ref) {
  var _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("button", {
      type: "button"
    }) : _ref$rc,
    testId = _ref.testId,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    domRef = _ref.domRef,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = "onClick" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      onClick: null
    }),
    onClick = _ref2.onClick,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var customStyles = useConvertSxToEmotionStyles(sx);
  var css = merge({
    // @NOTE Some basic reset styles:
    padding: 0,
    border: "none",
    background: "transparent",
    display: "inline-flex",
    alignItems: "baseline",
    cursor: "pointer",
    textDecoration: "none"
  }, customStyles);
  var mergedClassNames = "".concat(className !== null && className !== void 0 ? className : "", " BaseClickable");
  return cloneElementWithCssProp(rc, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, otherProps), testId ? {
    "data-testid": testId
  } : {}), domRef ? {
    ref: domRef
  } : {}), onClick ? {
    onClick: onClick
  } : {}), {}, {
    className: mergedClassNames,
    css: css,
    children: children
  }));
}
BaseClickable.displayName = "BaseClickable";

export { BaseClickable as B };
//# sourceMappingURL=BaseClickable.js.map
